import BackendService from 'BackendService';
import { Permissions } from 'Permission';
import { useEffect, useState } from 'react';
import { hasPermission } from './adminAppPermissionBridge';

export function useCreateOpportunity() {
  const [showCreateOppModal, setShowCreateOppModal] = useState(false);
  const [newOppName, setNewOppName] = useState('');
  const [newOppSummaryTitle, setNewOppSummaryTitle] = useState('');
  const [newOppNameError, setNewOppNameError] = useState<string | null>(null);
  const [newOppSummaryTitleError, setNewOppSummaryTitleError] = useState<string | null>(null);
  const [oppNavigate, setOppNavigate] = useState<string | null>(null);

  useEffect(() => {
    if (oppNavigate) {
      const timer = setTimeout(() => setOppNavigate(null), 0);
      return () => clearTimeout(timer);
    }
  }, [oppNavigate]);

  const createOpportunity = () => {
    if (!hasPermission?.(Permissions.FundOpportunityCreation)) {
      return;
    }

    if (hasPermission?.(Permissions.AIEntityCreation)) {
      setOppNavigate('/opportunities/new');
      return;
    }

    setShowCreateOppModal(true);
  };

  const submitNewOpp = () => {
    if (newOppName.trim() == '') {
      setNewOppNameError('Opportunity name must be supplied');
      return;
    }

    if (newOppSummaryTitle.trim() == '') {
      setNewOppSummaryTitleError('Opportunity summary title must be supplied');
      return;
    }

    new BackendService()
      .createFundOpportunity(newOppName, newOppSummaryTitle)
      .then((id) => {
        setShowCreateOppModal(false);
        setOppNavigate(`/opportunities/${id}`);
      })
      .catch((error) => {
        setNewOppNameError(error.message);
      });
  };

  return {
    showCreateOppModal,
    newOppName,
    newOppSummaryTitle,
    newOppNameError,
    newOppSummaryTitleError,
    oppNavigate,
    createOpportunity,
    submitNewOpp,
    setShowCreateOppModal,
    setNewOppName,
    setNewOppSummaryTitle,
    setOppNavigate,
  };
}
